
<template>
  <div class="be-signup">
    <form method="post" v-on:submit.prevent="login" class="login-form">
      <input v-model="credentials.email" name="email" class="form-control" type="email" autofocus placeholder="E-mail" autocomplete="off" required="required">
      <input v-model="credentials.password" name="password" class="form-control" type="password" placeholder="Password" autocomplete="off" required="required">
      <button class="btn btn-primary">Login</button>
    </form>
    <div class="clearfix"></div>
    <template v-if="currentUser.errors">
      <div v-for="msg in currentUser.errors" role="alert" class="alert alert-danger alert-contrast alert-dismissible">
        <div class="message">{{msg}}</div>
      </div>
    </template>
  </div>
</template>


<script>
import { mapState } from 'vuex'

export default {

  created() {
    this.$store.commit(`CLEAR_USER_ERRORS`);
  },

  //{"email": "bob@example.com", "password": "password", "password\_confirmation": "password"}
  methods: {
    login() {
      console.log(this.credentials);
      this.$store.dispatch('login', {user: {
        email: this.credentials.email,
        password: this.credentials.password,
      }})
    },
  },

  computed: {
    ...mapState([
      'currentUser'
    ])
  },

  data() {
    return {
      credentials: {
        email: null,
        password: null,
      }
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .login-form input {width:40%;float:left;height:31px;font-size:12px;}
  .login-form input:first-child { border-radius: 2px 0px 0px 2px; }
  .login-form button { width: 20%; float: left; border-radius: 0px 2px 2px 0px; }

  .alert {margin-top:10px;}
  .alert .message { padding: 5px 10px; }

</style>



// WEBPACK FOOTER //
// QuickLogin.vue?0cd5d122